<template>
  <div class="activity-add">
    <iModal
      title="上传视频"
      v-model="showModal"
      width="600px"
      :mask-closable="false"
      @on-cancel="close()"
      :styles="{top: '150px'}"
    >
      <div class="my-modal">
        <div class="my-modal-content">
          <Form :label-width="100" :rules="ruleInline" :model="formInline">
            <FormItem label="本地视频：" :required="true">
              <div
                class="my-upload-list"
                v-for="(item, index) in uploadList"
                :key="'upload' + index"
                style="width: 100px;height:100px;position: relative;"
              >
                <template v-if="item.status === 'finished'">
                  <!-- <img :src="videoImg" style="width: 100px;height:100px;" /> -->
                  <video v-if="item.url" :src="item.url" style="width: 100px;height:100px;"></video>
                  <div class="my-upload-list-cover">
                    <Icon type="ios-eye-outline" @click.native="handleView(item)"></Icon>
                    <Icon
                      type="ios-trash-outline"
                      @click.native.stop.prevent="handleRemoveByArr(item)"
                    ></Icon>
                  </div>
                </template>
              </div>
              <Upload
                ref="upload"
                :show-upload-list="false"
                :on-success="handleSuccess"
                :format="['mp4']"
                :max-size="51200"
                :headers="formHeaders"
                :on-format-error="handleFormatError"
                :on-error="handleUploadError"
                :on-exceeded-size="handleMaxSize"
                :before-upload="handleBeforeUpload"
                :on-progress="handleUploading"
                :action="uploadVideoUrl"
                type="drag"
                style="display: inline-block;width: 100px;height:100px;"
                v-show="uploadList && uploadList.length < 1"
              >
                <div style="width: 100px;height:100px;padding-top: 15px;">
                  <div style="font-size:20px">
                    +
                    <p style="font-size:14px">上传</p>
                  </div>
                </div>
              </Upload>
              <div class="uploading" v-if="uploading">
                <Spin>
                  <Icon type="ios-loading" size="20" class="demo-spin-icon-load"></Icon>
                </Spin>
              </div>
              <p class="upload-p" style="font-size:12px">（视频要求：大小不超过50M，建议时长9-30秒，宽高比16:9，只支持.mp4格式）</p>
            </FormItem>
            <FormItem label="名称：" prop="name">
              <Input v-model="formInline.name" placeholder="请输入视频名称，不超过20字" />
            </FormItem>
            <!-- <FormItem label="封面：">
              <RadioGroup v-model="formInline.cover">
                <Radio size="large" label="0">截取</Radio>
                <Radio size="large" label="1">自定义</Radio>
              </RadioGroup>
            </FormItem> -->

            <div style="margin-top: 20px;">
              <div v-if="formInline.cover == 0">
                <FormItem label="截取帧：">
                  <RadioGroup v-model="picture" type="button" @on-change="pictureChange">
                    <Radio label="5秒"></Radio>
                    <Radio label="10秒"></Radio>
                    <Radio label="15秒"></Radio>
                    <Radio label="20秒"></Radio>
                    <Radio label="25秒"></Radio>
                  </RadioGroup>
                </FormItem>
                <FormItem label="预览：">
                  <div class="preview-box">
                    <img :src="this.coverImg" v-if="coverImg" style="width: 100px;height:100px;" />
                    <img src="@/assets/img/empty.png" v-else style="width: 100px;height:100px;" />
                  </div>
                </FormItem>
              </div>

              <FormItem v-if="formInline.cover == 1" label="封面：">
                <div
                  class="my-upload-list"
                  v-for="(item, index) in uploadList2"
                  :key="'upload' + index"
                  style="width: 100px;height:100px;"
                >
                  <template v-if="item.status === 'finished'">
                    <img :src="item.url" style="width: 100px;height:100px;" />
                    <div class="my-upload-list-cover">
                      <Icon
                        type="ios-trash-outline"
                        @click.native.stop.prevent="handleRemoveByArr2(item)"
                      ></Icon>
                    </div>
                  </template>
                  <template v-else>
                    <Spin v-if="item.showProgress" style="width: 100px;height:100px;">
                      <Icon type="ios-loading" size="20" class="demo-spin-icon-load"></Icon>
                    </Spin>
                  </template>
                </div>
                <Upload
                  ref="upload2"
                  :show-upload-list="false"
                  :on-success="handleSuccess2"
                  :format="['jpg','jpeg','png']"
                  :max-size="2048"
                  :headers="formHeaders"
                  :on-format-error="handleFormatError2"
                  :on-exceeded-size="handleMaxSize2"
                  :before-upload="handleBeforeUpload2"
                  type="drag"
                  :action="uploadUrl"
                  multiple
                  style="display: inline-block;width: 100px;height:100px;"
                  v-show="uploadList2 && uploadList2.length < 1"
                >
                  <div style="width: 100px;height:100px;padding-top: 15px;">
                    <div style="font-size:20px">
                      +
                      <p style="font-size:14px">上传</p>
                    </div>
                  </div>
                </Upload>
                <p style="font-size: 12px;">(图片要求：2M以下的jpg或png，建议尺寸750*500px)</p>
              </FormItem>
            </div>
          </Form>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" :loading="loading" @click="handleSubmit()">保存</Button>
        <Button @click="close()">取消</Button>
      </div>
    </iModal>
    <iModal cancel-text v-model="visible" class-name="vertical-center-modal" :footer-hide="false">
      <div style="text-align: center;">
        <video-player
          class="video-player vjs-custom-skin"
          ref="videoPlayer"
          :playsinline="true"
          :options="playerOptions"
          @play="onPlayerPlay($event)"
          @pause="onPlayerPause($event)"
        ></video-player>
      </div>
    </iModal>
  </div>
</template>

<script>
require("video.js/dist/video-js.css");
require("vue-video-player/src/custom-theme.css");
import { mapActions, mapGetters } from "vuex";
import { videoPlayer } from "vue-video-player";
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showModal: false,
      loading: false,
      uploading: false,
      uploadList: [],
      uploadList2: [],
      visible: false,
      formInline: {
        cover: "1",
        name: ""
      },
      picture: "5秒", // 视频封面的帧数
      coverImg: "",
      videoData: null,
      ruleInline: {
        // 效验规则
        name: [
          { required: true, message: "视频名称不能为空", trigger: "blur" },
          {
            type: "string",
            max: 20,
            message: "用户名不能大于20位",
            trigger: "blur"
          }
        ]
      }
    };
  },
  watch: {
    show(val, oldVal) {
      this.showModal = val;
      if (!val) this.$emit("close");
    }
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      uploadUrl: "getUploadUrl",
      uploadVideoUrl: "getUploadVideoUrl",
      formHeaders: "getFormHeaders"
    }),
    // videoImg() {
    //   let url = "";
    //   if (this.uploadList && this.uploadList.length) {
    //     let suffix =
    //       "?x-image-process=video/snapshot,t_2000,f_jpg,w_590,h_332,m_fast";
    //     url = this.uploadList[0].url + suffix;
    //   }
    //   return url;
    // },
    playerOptions() {
      let res = {};
      if (this.videoData) {
        res = {
          autoplay: false,
          muted: false,
          loop: false,
          preload: "auto",
          language: "zh-CN",
          aspectRatio: "16:9",
          fluid: true,
          sources: [
            {
              type: "video/mp4",
              src: this.videoData.url
            }
          ],
          // poster: this.videoImg,
          width: document.documentElement.clientWidth,
          notSupportedMessage: "此视频暂无法播放，请稍后再试"
        };
      }
      return res;
    }
  },
  components: {
    videoPlayer
  },
  methods: {
    ...mapActions({
      addvideoMaterial: "materialModule/addvideoMaterial"
    }),
    handleSuccess(res, file) {
      this.uploading = false;
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList = this.$refs.upload.fileList;
        // 华为云暂无此功能
        // this.coverImg =
        //   this.uploadList[0].url +
        //   `?x-image-process=video/snapshot,t_${5000},f_jpg,w_590,h_332,m_fast`;
        this.formInline.name = this.uploadList[0].name;
      }
    },
    handleSuccess2(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList2 = this.$refs.upload2.fileList;
      }
    },
    // 查看上传图片
    handleView(name) {
      this.videoData = name;
      this.visible = true;
    },
    handleFormatError(file) {
      this.$Message.warning(`文件格式是不正确的, 请上传mp4格式的视频`);
      this.uploading = false;
    },
    handleUploadError(file) {
      this.$Message.warning({
        content: "您的网络请求已超时,请重新上传",
        duration: 3,
        closable: true
      });
      this.uploading = false;
    },
    handleFormatError2(file) {
      this.$Message.warning(`文件格式是不正确的, 请上传jpg或者png格式的图片`);
    },
    handleMaxSize(file) {
      this.$Message.warning(`文件大小超过限制, 请上传小于50M以下mp4格式的视频`);
    },
    handleMaxSize2(file) {
      this.$Message.warning(`文件大小超过限制, 请上传小于2M的图片`);
    },
    handleRemoveByArr(file) {
      const fileList = this.uploadList;
      this.uploadList.splice(fileList.indexOf(file), 1);
    },
    handleRemoveByArr2(file) {
      const fileList2 = this.uploadList2;
      this.uploadList2.splice(fileList2.indexOf(file), 1);
    },
    handleBeforeUpload() {
      this.uploading = true;
      const limitNum = 1;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Message.warning(`一次只能上传${limitNum}条视频`);
      }
      return check;
    },
    handleBeforeUpload2() {
      const check = this.$refs.upload2.fileList.length < 1;
      if (!check) {
        this.$Message.warning(`最多只能上传1张封面`);
      }
      return check;
    },
    handleUploading(event) {},
    transfromImgList(arr) {
      let arr2 = [];
      arr.forEach(c => {
        arr2.push(c.url);
      });
      return arr2;
    },
    transfromImgList2(arr) {
      let arr2 = [];
      arr.forEach(c => {
        let url = c.url;
        if (this.formInline.cover === "0") {
          let suffix =
            "?x-image-process=video/snapshot,t_2000,f_jpg,w_590,h_332,m_fast";
          url += suffix;
        }
        arr2.push(url);
      });
      return arr2;
    },
    async handleSubmit() {
      if (!(this.uploadList && this.uploadList.length)) {
        this.$Message.error(`请上传素材视频`);
        return;
      }
      let videoList = this.transfromImgList(this.uploadList);
      if (this.formInline.cover === "1") {
        if (this.uploadList2.length > 0) {
          this.coverImg = this.uploadList2[0].url;
        } 
        // else {
        //   this.$Message.error(`请上传视频封面`);
        //   return;
        // }
      }
      let second = this.getIntArr(this.picture);
      let formData = {
        CompId: this.company.id,
        AgentId: this.company.agentId,
        Name: this.formInline.name,
        VideoInfo: {
          Cover: "1",
          Time: second[0] * 1000,
          Img: this.coverImg,
          Link: String(videoList)
        },
        StyleId: "3",
        Introduction: "",
        Tag: ""
      };
      console.log(formData);
      this.loading = true;
      let bool = await this.addvideoMaterial(formData);
      this.loading = false;
      if (bool.successed) {
        this.$Message.success("添加成功");
        this.$emit("finish");
        this.close();
        this.$refs.upload.clearFiles();
      } else {
        this.$Message.error("添加失败，请重新尝试");
      }
    },
    close() {
      this.showModal = false;
      this.loading = false;
      this.uploadList = [];
      this.uploadList2 = [];
      this.visible = false;
      this.videoData = null;
      this.coverImg = "";
      this.from = "";
      this.formInline.cover = "1";
      this.formInline.name = "";
      this.uploading = false;
      if (this.$refs["upload"]) this.$refs["upload"].clearFiles();
      if (this.$refs["upload2"]) this.$refs["upload2"].clearFiles();
      this.$refs.upload.clearFiles();
      this.$emit("close");
    },
    onPlayerPlay(player) {},
    onPlayerPause(player) {},
    pictureChange(e) {
      let second = this.getIntArr(e);
      console.log(second);
      if (this.uploadList[0] && this.uploadList[0].url) {
        this.coverImg =
          this.uploadList[0].url +
          `?x-image-process=video/snapshot,t_${second[0] *
            1000},f_jpg,w_590,h_332,m_fast`;
      }
    },
    getIntArr(str) {
      return str
        .replace(/[^0-9]/gi, " ")
        .trim()
        .split(/\s+/);
    }
  },
  mounted() {
    if (this.$refs.upload) {
      this.uploadList = this.$refs.upload.fileList;
    }
  }
};
</script>

<style lang="scss" scoped>
.my-modal {
  &-content {
    padding-right: 20px;
  }
}
.video-player {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  max-width: 100%;
  max-height: 100%;
  margin: auto;
}
.my-upload-list-cover {
  i {
    position: relative !important;
    top: -2px !important;
  }
}
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}

.preview-box {
  width: 100px;
  height: 100px;
  background-color: #bfbfbf;
  border-radius: 5px;
  position: relative;
  img {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
  }
}
</style>